import { render, staticRenderFns } from "./DoubleChoiceCard.vue?vue&type=template&id=579c957e&scoped=true&"
import script from "./DoubleChoiceCard.vue?vue&type=script&lang=js&"
export * from "./DoubleChoiceCard.vue?vue&type=script&lang=js&"
import style0 from "./DoubleChoiceCard.vue?vue&type=style&index=0&id=579c957e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579c957e",
  null
  
)

export default component.exports